// In src/DriverCentral.js

import React, { useState } from 'react';
import { auth } from './firebase';
import { FaPaperPlane, FaSpinner } from 'react-icons/fa';


function DriverCentral() {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [category, setCategory] = useState('News');
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState('');
const [linkUrl, setLinkUrl] = useState(''); // ✅ NEW: State for the clickable link
  const [file, setFile] = useState(null);     // ✅ NEW: State for the uploaded file
const handlePostContent = async (e) => {
  e.preventDefault();
  if (!title || !content) {
    setError("Title and content cannot be empty.");
    return;
  }
  setIsProcessing(true);
  setError('');

  try {
    const user = auth.currentUser;
    if (!user) throw new Error("You are not logged in.");
    // Get the "ID card"
    const idToken = await user.getIdToken(true);
    const formData = new FormData();
      formData.append('title', title);
      formData.append('content', content);
      formData.append('category', category);
      formData.append('linkUrl', linkUrl);
      if (file) {
        formData.append('attachment', file);
      }

    // Use the same fetch pattern as your other working functions
    const result = await fetch("https://us-central1-drivio-dashboard-40e1f.cloudfunctions.net/postDriverCentralContent", {
  method: "POST",
  headers: {
    // REMOVE the "Content-Type" header. The browser will set it automatically for FormData.
    "Authorization": `Bearer ${idToken}` 
  },
  // SEND the FormData object directly. Do NOT use JSON.stringify.
  body: formData, 
});

    if (!result.ok) {
      const errorData = await result.json();
      throw new Error(errorData.error || "Failed to post content.");
    }

    alert("Content posted successfully!");
    setTitle('');
    setContent('');
    setCategory('News');
    setLinkUrl('');
      setFile(null);

  } catch (err) {
    setError(err.message);
    alert(`Error: ${err.message}`);
  } finally {
    setIsProcessing(false);
  }
};
  return (
    <div className="card">
      <h2 className="page-header">Post to Driver Central</h2>
      <p className="page-subheader">Create and send news, contest announcements, and other updates to your drivers.</p>
      
      <form onSubmit={handlePostContent} className="content-form">
        <div className="form-group">
          <label htmlFor="title">Title</label>
          <input
            id="title"
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="form-input"
            placeholder="e.g., New Weekly Contest!"
          />
        </div>
        <div className="form-group">
          <label htmlFor="category">Category</label>
          <select
            id="category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            className="form-input"
          >
            <option value="News">News</option>
            <option value="Contests">Contests</option>
            <option value="Events">Events</option>
            <option value="Media">Media</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="content">Content</label>
          <textarea
            id="content"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            className="form-input"
            rows="8"
            placeholder="Write your announcement here..."
          />
        </div>
        {/* ✅ NEW: Input for a clickable URL */}
        <div className="form-group">
          <label htmlFor="linkUrl">Clickable Link (Optional)</label>
          <input
            id="linkUrl"
            type="url"
            value={linkUrl}
            onChange={(e) => setLinkUrl(e.target.value)}
            className="form-input"
            placeholder="e.g., https://www.your-link.com"
          />
        </div>
        
        {/* ✅ NEW: Input for a file/image attachment */}
        <div className="form-group">
          <label htmlFor="attachment">Attach Image or File (Optional)</label>
          <input
            id="attachment"
            type="file"
            onChange={(e) => setFile(e.target.files[0])}
            className="form-input"
          />
        </div>
        
        
        {error && <p className="error-text" style={{textAlign: 'left', marginBottom: '16px'}}>{error}</p>}

        <button type="submit" className="btn btn-primary" disabled={isProcessing}>
          {isProcessing ? <FaSpinner className="animate-spin" /> : <FaPaperPlane />}
          {isProcessing ? 'Posting...' : 'Post Content'}
        </button>
      </form>
    </div>
  );
}

export default DriverCentral;